import React from 'react';
import { AssetWith5050Text } from '../AssetWith5050Text';
import { IContentBlock5050Fields } from '@/types/contentful';
import { normalizeHexCode } from '~/styles/utils';

export function ContentBlock5050({
  headline,
  backgroundColor,
  topGradientColor,
  bottomGradientColor,
  assetBlocks
}: IContentBlock5050Fields) {
  return (
    <div className="relative mb-24" data-testid="content-block-5050">
      <h2 className="heading-2 relative mb-16 mt-12 w-full text-center">
        {headline}
      </h2>
      <div
        className="relative"
        style={{
          background: `${
            backgroundColor ?? normalizeHexCode(backgroundColor)
          } ${
            topGradientColor && bottomGradientColor && !backgroundColor
              ? `linear-gradient(to bottom, ${normalizeHexCode(
                  topGradientColor
                )}, ${normalizeHexCode(bottomGradientColor)})`
              : ''
          }`
        }}
      >
        {assetBlocks?.map(({ sys, fields }: any) => (
          <section key={sys?.id} data-cfid={sys?.id}>
            <AssetWith5050Text {...fields} />
          </section>
        ))}
      </div>
    </div>
  );
}
